(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    // --- Galeria de producto (cambiar imagen con miniatura) ---
    var thumbs = document.querySelector('[data-gallery-thumbs]');
    if (thumbs) {
      var mainImg = document.getElementById('product-gallery-main');
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-full]') : null;
        if (!btn || !mainImg) return;
        mainImg.src = btn.getAttribute('data-full');
        var alt = btn.getAttribute('data-alt');
        if (alt) mainImg.alt = alt;
        var act = thumbs.querySelector('.is-active');
        if (act) act.classList.remove('is-active');
        btn.classList.add('is-active');
      });
    }

    // --- Carrito lateral (drawer) ---
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (drawer) {
      function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
      function fmtMoney(cents) {
        try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100); }
        catch (e) { return '$' + (cents / 100).toLocaleString('es-CO'); }
      }
      function thumb(u) { return u.replace(/\.(png|jpe?g|webp|gif)(\?|$)/i, '_100x100.$1$2'); }
      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('show'); }); }
        document.body.classList.add('cart-open');
        loadCartItems();
      }
      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) { overlay.classList.remove('show'); setTimeout(function () { overlay.hidden = true; }, 260); }
        document.body.classList.remove('cart-open');
      }
      function loadCartItems() {
        var box = document.querySelector('[data-cart-drawer-items]');
        var total = document.querySelector('[data-cart-drawer-total]');
        if (!box) return;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart.items || !cart.items.length) {
              box.innerHTML = '<p class="cart-drawer-empty">Tu carrito está vacío.</p>';
            } else {
              box.innerHTML = cart.items.map(function (it) {
                var img = it.image ? '<img src="' + thumb(it.image) + '" alt="' + esc(it.product_title || it.title) + '" loading="lazy">' : '';
                var varTxt = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="cart-drawer-item-variant">' + esc(it.variant_title) + '</span>' : '';
                return '<div class="cart-drawer-item">' +
                  '<a class="cart-drawer-item-media" href="' + it.url + '">' + img + '</a>' +
                  '<div class="cart-drawer-item-info">' +
                    '<a class="cart-drawer-item-title" href="' + it.url + '">' + esc(it.product_title || it.title) + '</a>' + varTxt +
                    '<span class="cart-drawer-item-price">' + fmtMoney(it.final_line_price) + (it.quantity > 1 ? ' \u00d7 ' + it.quantity : '') + '</span>' +
                  '</div>' +
                  '<button type="button" class="cart-drawer-remove" data-remove="' + esc(it.key) + '" aria-label="Eliminar ' + esc(it.product_title || it.title) + '">' +
                    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
                  '</button>' +
                '</div>';
              }).join('');
            }
            if (total) total.textContent = fmtMoney(cart.total_price);
          })
          .catch(function () {});
      }
      drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

      var itemsBox = document.querySelector('[data-cart-drawer-items]');
      if (itemsBox) {
        itemsBox.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('[data-remove]') : null;
          if (!btn) return;
          var key = btn.getAttribute('data-remove');
          if (!key) return;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          })
            .then(function (r) { if (!r.ok) throw new Error('change error'); return r.json(); })
            .then(function () { updateCartCount(); loadCartItems(); })
            .catch(function () {});
        });
      }
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

      var headerCart = document.querySelector('.header-cart');
      if (headerCart) {
        headerCart.addEventListener('click', function (e) {
          e.preventDefault();
          if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
        });
      }

      var productForm = document.querySelector('[data-product-form]');
      if (productForm) {
        productForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = productForm.querySelector('button[type=submit]');
          var orig = btn ? btn.textContent : '';
          if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
          fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm), headers: { 'Accept': 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('add error'); return r.json(); })
            .then(function () { updateCartCount(); openDrawer(); })
            .catch(function () { window.location.href = '/cart'; })
            .then(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
        });
      }
    }

    // --- Menú móvil ---
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-nav]');
    var overlay = document.querySelector('[data-menu-overlay]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        nav.classList.toggle('is-open');
        if (overlay) overlay.classList.toggle('is-open');
        document.body.classList.toggle('menu-open');
      });
      if (overlay) {
        overlay.addEventListener('click', function () {
          nav.classList.remove('is-open');
          overlay.classList.remove('is-open');
          document.body.classList.remove('menu-open');
        });
      }
    }

    // --- Contador de carrito (live) ---
    function updateCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var els = document.querySelectorAll('[data-cart-count]');
          for (var i = 0; i < els.length; i++) {
            els[i].textContent = cart.item_count || 0;
          }
        })
        .catch(function () { /* silencioso */ });
    }
    updateCartCount();

    // --- Anuncio cerrable ---
    var closeAnnouncement = document.querySelector('[data-announcement-close]');
    if (closeAnnouncement) {
      closeAnnouncement.addEventListener('click', function () {
        var bar = document.querySelector('[data-announcement]');
        if (bar) bar.style.display = 'none';
      });
    }

    // --- Confeti de bienvenida (una vez por sesión, colores de marca VORTEX) ---
    (function () {
      try {
        if (sessionStorage.getItem('vortex_confetti_done')) return;
      } catch (e) { return; }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var COLORS = ['#00A6A6', '#E11D48', '#0E1116', '#FFFFFF', '#C56443', '#5F7A48'];
      var COUNT = 90;
      var container = document.createElement('div');
      container.setAttribute('aria-hidden', 'true');
      container.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden';
      document.body.appendChild(container);

      for (var i = 0; i < COUNT; i++) {
        var p = document.createElement('span');
        var size = 6 + Math.random() * 8;
        var color = COLORS[Math.floor(Math.random() * COLORS.length)];
        var left = Math.random() * 100;
        var delay = Math.random() * 0.8;
        var duration = 2.8 + Math.random() * 2;
        var round = Math.random() > 0.5 ? '50%' : '2px';
        p.style.cssText = 'position:absolute;top:-14px;left:' + left + '%;width:' + size + 'px;height:' + size + 'px;background:' + color + ';border-radius:' + round + ';opacity:0;animation:confetti-fall ' + duration + 's ease-in ' + delay + 's forwards';
        container.appendChild(p);
      }
      setTimeout(function () { container.remove(); }, 6800);
      try { sessionStorage.setItem('vortex_confetti_done', '1'); } catch (e) {}
    })();

    // --- Notificación social proof: ventas en vivo (aparece y desaparece) ---
    (function () {
      try {
        var shown = parseInt(sessionStorage.getItem('vortex_salespop_shown') || '0', 10);
        if (shown >= 5) return; // máx. 5 avisos por sesión para no molestar
      } catch (e) {}
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var PRODUCTS = ['Audífonos Bluetooth M10', 'Bombillo Inteligente RGB', 'Cámara WiFi Mini A9', 'Cargador Rápido 33W USB-C', 'Masajeador de Pies Eléctrico'];
      var CITIES = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Bucaramanga', 'Pereira', 'Manizales', 'Santa Marta', 'Ibagué', 'Cartagena'];
      var TEMPLATES = [
        function (n, prod, city) { return '<strong>' + n + ' personas</strong> tienen esto en su carrito ahora'; },
        function (n, prod, city) { return 'Alguien en <strong>' + city + '</strong> compró <strong>' + prod + '</strong> hace unos minutos'; },
        function (n, prod, city) { return '<strong>' + n + ' personas</strong> compraron <strong>' + prod + '</strong> hoy'; },
        function (n, prod, city) { return 'Quedan pocas unidades de <strong>' + prod + '</strong> — ' + n + ' lo vieron hoy'; }
      ];

      var pop = document.createElement('div');
      pop.className = 'vortex-sales-pop';
      pop.setAttribute('role', 'status');
      pop.setAttribute('aria-live', 'polite');
      document.body.appendChild(pop);

      var showing = false;
      var timer = null;

      function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

      function bump() {
        try { sessionStorage.setItem('vortex_salespop_shown', String(parseInt(sessionStorage.getItem('vortex_salespop_shown') || '0', 10) + 1)); } catch (e) {}
      }

      function show() {
        if (showing) return;
        var n = rand(4, 20);
        var prod = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
        var city = CITIES[Math.floor(Math.random() * CITIES.length)];
        var t = TEMPLATES[Math.floor(Math.random() * TEMPLATES.length)];
        pop.innerHTML = '<span class="vortex-sales-pop-dot">&#9679;</span><span>' + t(n, prod, city) + '</span>';
        pop.classList.add('show');
        showing = true;
        bump();
        timer = setTimeout(hide, rand(5000, 8000));
      }

      function hide() {
        pop.classList.remove('show');
        showing = false;
        timer = setTimeout(show, rand(12000, 30000));
      }

      pop.addEventListener('click', function () { clearTimeout(timer); hide(); });
      timer = setTimeout(show, rand(8000, 20000));
    })();

    

    // --- Botón volver arriba ---
    (function () {
      var btn = document.querySelector('[data-vortex-top]');
      if (!btn) return;
      var onScroll = function () {
        if (window.scrollY > 600) btn.classList.add('show');
        else btn.classList.remove('show');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    })();

            // --- Temporizador del carrito: 15 minutos (sincronizado con la oferta flash) ---
    var cartTimer = document.querySelector('[data-cart-timer]');
    if (cartTimer) {
      var pad15 = function (n) { return (n < 10 ? '0' : '') + n; };
      var endCart15 = Date.now() + 900000; /* 15 minutos desde que se carga la pagina */
      function tickCart15() {
        var rem = Math.max(0, Math.floor((endCart15 - Date.now()) / 1000));
        if (rem <= 0) { endCart15 = Date.now() + 900000; rem = 900; }
        cartTimer.textContent = pad15(Math.floor(rem / 60)) + ':' + pad15(rem % 60);
      }
      tickCart15();
      setInterval(tickCart15, 1000);
    }

    // --- Acordeones (specs / FAQ usan <details>) ---
    // Se soporta de forma nativa; aquí solo se cierra un details al abrir otro (opcional).

    // --- Fijar header al hacer scroll ---
    var header = document.querySelector('[data-header]');
    if (header) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 8) {
          header.classList.add('is-sticky');
        } else {
          header.classList.remove('is-sticky');
        }
      }, { passive: true });
    }

    // --- Banner de oferta con cuenta regresiva (opcional) ---
    var countdown = document.querySelector('[data-countdown]');
    if (countdown && countdown.dataset.countdown) {
      var end = new Date(countdown.dataset.countdown).getTime();
      var timer = setInterval(function () {
        var now = new Date().getTime();
        var diff = end - now;
        if (diff <= 0) { clearInterval(timer); countdown.textContent = 'La oferta terminó'; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        countdown.textContent =
          (d > 0 ? d + 'd ' : '') +
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
      }, 1000);
    }
  });
})();
